<template>
  <!-- 隐私协议 author: zhangxiaofeng-->
  <div class="content-box privacy--main">
    <h2>
      广联达隐私政策
    </h2>
    <div class="part">
      最后更新日期：2019年[ 3 ]月[ 20 ]日
      <br>
    </div>
    <div class="part">
      您的隐私对我们至关重要。在广联达，我们的基本理念是“用户至上”。 这一价值贯穿我们做出的所有决定，包括我们如何收集、使用、分享、存储和尊重您的个人信息。由于我们的隐私政策与我们提供的服务（定义如下）密切相关，请仔细阅读本隐私政策，并在必要时做出适当的选择。
    </div>
    <div class="part">
      我们在制定本隐私政策时，尽可能做到清晰明了。我们的目标是让您——我们的用户 ——能始终了解广联达如何保护您的隐私以及对您所拥有的权利。
    </div>
    <div class="part">
      1.
      <br>
      ●	什么时候适用隐私政策
      <br>
      我们的隐私政策适用于[  造价云产品  ]以及其他由我们运营并向您提供服务的网站（zjy.glodon.com），我们的移动设备应用程序（“造价云移动应用”）以及可通过移动应用或可在个人计算机上安装并使用的软件产品（以下统称为“产品”）。本隐私政策仅适用于我们的“服务”中包含的网站、产品、服务和应用程序，包含但不限于造价云空间、造价云APP、造价云微信小程序，云计价产品中提供的智能组价、组价方案、云存档、特征及内容、云检查、指标等。
      <br>
      请务必阅读本隐私政策以及我们在特定情况下收集或处理您的个人数据时提供的任何其他隐私政策或公平处理政策，以便您能充分了解我们使用您的数据的目的和方式。本隐私政策是对其他声明和隐私政策的补充而非旨在取代前述声明或隐私政策。
      <br>
      除非本隐私政策具体章节中另有规定，本隐私政策中的术语与用户协议中（如有）的术语应具有相同的含义。
      <br>
      请注意，隐私政策不适用于以下情况：
      <br>
      ●	任何第三方服务（包括任何第三方网站）通过我们的服务所收集的信息；
      <br>
      ●	其他提供广告服务的公司或机构通过我们的服务所收集的信息。
      <br>
      在上述情况下，您应该直接查阅相关第三方的隐私政策。
      <br>
      ●	本隐私政策的目的
      <br>
      本隐私政策旨在向您说明广联达在您服务的过程中如何收集，存储和处理您的个人数据，包括您通过我们的服务提供的任何数据。
      <br>
      ●	数据控制者
      <br>
      广联达科技股份有限公司（以下统称为“广联达”，“我们”或“我们的”）是您的个人数据的控制者并对您的个人数据负责。
      <br>
      ●	联系方式
      <br>
      如果您对本隐私政策或我们的隐私措施有任何疑问，请通过以下方式与我们联系：
      <br>
      公司全名：广联达科技股份有限公司；
      <br>
      邮箱地址：webmaster@glodon.com；
      <br>
      邮寄地址：北京市海淀区东北旺西路10号院中关村软件园13号楼广联达信息大厦；
      <br>
      ●	隐私政策的变更
      <br>
      我们的隐私政策可能会不断更新，这些更新可能仅针对隐私政策的部分内容。对某些可能会影响您的权利的重要更新，我们将在修订生效之前，在我们的主页上提供更为醒目的通知，或通过发送电子邮件或其他方式通知您。在这种情况下，如果您继续使用我们的服务，将被视为您已同意我们修订后的隐私政策。
      <br>
      ●	第三方链接
      <br>
      我们的服务可能包含指向第三方网站、插件和应用程序的链接。点击这些链接或启用这些连接可能允许第三方收集或共享与您有关的数据。我们无法控制该等第三方网站，亦不对他们的隐私政策负责。您应自行决定使用这些链接。当您跳转离开我们的网站时，我们建议您阅读您访问的每个网站的隐私政策。
      <br>
    </div>
    <div class="part">
      2.	我们收集的与您相关的数据
      <br>
      个人数据或个人信息是指，任何与个人相关且可通过该等信息识别该等个人的任何信息。个人信息不包括去识别化的数据（匿名数据）。
      <br>
      我们收集以下与您相关的信息：
      <br>
      ●	基本注册信息
      <br>
      如果您使用我们的网站或者下载、安装我们的产品时，创建了与您使用任何服务相关的账号（“账号”），您需要提供您的电子邮箱地址以完成注册。如需使用我们的服务，您可能还需要提供您的姓名或昵称、性别、生日、公司、地址等。如果您通过我们的服务加入某个项目，您的项目管理员可能向我们提供您的部门和职位，或更改您提供的名称。
      <br>
      我们不会收集任何与您相关的特殊类别的个人数据（包括您的种族或民族、宗教或哲学信仰、性生活、性取向、政治观点、工会身份、您的健康信息以及遗传和生物数据等的详细信息）。我们也不会收集有关刑事犯罪和违法行为的任何信息。
      <br>
      ●	与交易有关的信息
      <br>
      当您（包括当你代表您的公司）在线购买我们的产品或订购我们的服务时，将会有销售人员为您下单，下单后您可以通过银行转账或汇款的方式进行支付。如果您选择第三方在线支付的方式来支付订单时，我们不会收集您的交易信息，如您的信用卡信息、借记卡信息以及您的在线支付密码等。在这种情况下，您应直接查阅相关的第三方服务提供商的隐私政策，以获取有关他们如何处理交易数据的详细信息。
      <br>
      我们仅收集如下信息以验证您对我们的产品或服务的购买和订购，包括付款金额、您购买的产品或订购的服务、您的邮寄地址以及您的公司信息。
      <br>
      ●	与使用服务有关的信息
      <br>
      当您安装、激活、更新、卸载相关产品或服务时，我们的服务器会自动记录有关您如何使用我们服务的某些数据（“日志数据”）。日志数据可能包括诸如您的注册时间和日期、您对我们服务的使用、访问的日期和时间、您的IP地址，使用的产品id，您的账号信息等特定数据。我们使用日志数据来管理服务，我们将分析（或可能聘请第三方参与分析）日志数据以达到改进、定制和提升我们的服务的目的。我们可能会使用统计数据等汇总数据来改善我们的服务。汇总数据可能来自您和他人的个人数据，但汇总数据本身并不构成个人数据，因为这些数据不会直接或间接揭示您或他人的身份。例如，我们可能会汇总您的日志数据，以计算访问特定网站功能的用户的百分比。但是，如果我们将汇总数据与您的个人数据相互结合或相互联系并使得汇总数据可以直接或间接识别到您时，我们将把结合后的数据视为个人数据，并将按照本隐私政策来使用该等个人数据。
      <br>
      ●	与设备相关的信息
      <br>
      在您使用我们的服务时，我们可能会收集您的设备所发送的某些数据，例如互联网协议（IP）地址、MAC地址、操作系统、浏览器类型、您使用的语言、CPU、屏幕分辨率、图形处理单元、内存、硬件驱动器、硬盘编号、浏览器、手机的国际移动设备识别码（IMEI）、以及我们服务的独立用户ID等。
      <br>
      ●	从我们的合作伙伴和其他第三方收集的信息
      <br>
      我们可能会将您的订购信息与我们从合作伙伴或其他第三方（如Google Analytics等）收集到的数据信息相互联系，以协助我们更好地为您提高我们的服务，更好地了解您的需求，并为您提供更优质的服务。
      <br>
      ●	使用Cookie和其他Web技术收集的信息
      <br>
      Cookie和匿名标识符。Cookie的主要功能是方便您使用本网站和/或服务，并帮助网站统计独立访客的数量。
      <br>
      当您使用我们的服务时，Cookie将被发送到您的设备。当您与我们向合作伙伴提供的服务（如广告促销服务以及可能出现在其他网站上的、由广联达提供的服务功能）进行交互时，我们还允许将Cookie或匿名标识符传输到广联达的服务器。
      <br>
      您可以选择通过修改浏览器设置来关闭Cookie。如果您选择关闭Cookie，则可能无法登录或使用某些依赖Cookie实现的广联达的服务或功能。当您访问广联达网站时，如果您不希望广联达向您提供基于Cookie的个性化促销信息，您可以在浏览器中自定义Cookie设置。
      <br>
      我们使用Google Analytics工具用以更好地了解您与我们在线服务的互动。您可以在此处（https://tools.google.com/dlpage/gaoptout）选择退出Google Analytics。
      <br>
      ●	如果您未能提供个人数据
      <br>
      如果根据法律法规的规定或根据我们与您签订的合同条款，我们需要收集个人数据但您未能按照要求提供该数据时，我们可能无法履行我们已经或正在尝试与您签订的合同（例如，为您提供商品或服务）。 在这种情况下，我们可能必须取消您所使用的我们的产品或服务。如出现上述这种情况时，我们会通知您。
      <br>
    </div>
    <div class="part">
      3.	我们如何使用您的信息
      <br>
      我们只会在法律允许的情况下使用您的个人数据。通常在下列情形下，我们将使用您的个人数据，如果：
      <br>
      ●	出于签订和履行合同以提供服务的目的，或为了在签订和履行合同以提供服务之前，执行您要求的任何步骤。
      <br>
      ●	对我们的合法利益（或第三方的合法利益）而言确有必要，且您的利益和基本权利没有超越这些利益时。我们可能会基于我们的合法利益，使用您的个人信息：改进我们的服务、与您取得联系、处理、更新和管理我们的客户注册体系、研究、用户画像、满足您对产品和服务的要求、在您登录帐户时识别您的身份，验证您的交易，验证购买行为，计费，安全，身份验证，以及其他基于我们合法利益的其他目的，如果其中与所列目的不同，我们将通知您。
      <br>
      ●	我们需要遵守法律法规所规定的义务。
      <br>
    </div>
    <div class="part">
      4.	数据画像
      <br>
      我们将会使用通过我们的服务中所收集的您的个人数据进行数据画像，这些个人数据包括您的账户信息、日志数据、设备数据等。我们将利用数据画像来改善我们的服务，并且您有权拒绝对您的数据画像。如您需要行使您的权利，请参照本隐私政策“第8部分：您的权利”中的途径联系我们。
      <br>
    </div>
    <div class="part">
      5.	我们共享的信息
      <br>
      在未征得您的事先同意时，除下列情况外，我们将不会与任何第三方共享您的个人信息：
      <br>
      ●	与我们的服务提供商共享的信息
      <br>
      我们可能与我们的关联公司、合作伙伴、第三方服务提供商、承包商以及代理商（包括以广联达的名义向您发送邮件或者短信的通信服务提供商；部分服务提供商可能位于与您不同的国家）共享您的个人数据，以实现如下目的：（i）向您提供服务；（ii）实现“我们所收集的与您相关的数据”章节中所说明的目标；（iii）履行我们的义务或行使我们的权利（详情请见用户协议或隐私政策）；（iv）提供、维护及改善我们的服务。
      <br>
      我们将采取必要的措施要求第三方遵守本隐私政策所确定的标准，确保第三方可以通过恰当、安全的方式处理您的个人信息。
      <br>
      ●	商业交易中披露的信息
      <br>
      我们的业务正在快速增长，广联达可能因此进行合并、收购、资产出售及其他类似的交易。您的个人数据可能作为交易的一部分被转移至我们的交易对方，我们将在交易允许的情况下，提前通知您关于您的数据转移情况。
      <br>
      ●	法律法规要求提供的信息
      <br>
      广联达与政府部门、执法机关的工作人员以及非官方组织开展合作，遵守并履行法律法规要求的义务。 我们有权在出现下列情形且我们相信确系必要、恰当的时候，向政府部门及执法机关的工作人员以及非官方组织披露您的任何信息：（i）对诉讼请求、法律程序（包括法院传票等）作出回应；（ii）保护我们、第三方或公众的财产、权利及安全；以及（iii）停止我们认为违法的、不道德的或可能招致诉讼的任何活动
      <br>
      ●	与第三方共享的其他信息
      <br>
      我们可能与第三方分享汇总数据及非个人数据，以进行行业研究及分析或出于其他类似的目的。
      <br>
      此外，我们可能会向与我们属于同一集团的其他公司以及您已同意和/或我们已经通知您的其他第三方分享您的个人信息。我们不会将您的个人信息传输，分享，披露，转让，出售或出租给与我们的业务运营无关的第三方。
      <br>

    </div>
    <div class="part">
      6.	信息安全和信息存储
      <br>
      我们仅在为实现本隐私政策中说明的目的所必要的时限内、或法律法规允许的时限内，存储您的个人信息。
      <br>
      您的信息将存储在我们服务提供商所提供的服务器中。
      <br>
      为保护您的信息，我们采用多种技术以避免您的信息发生丢失、滥用、未授权的访问或泄露等情形，例如，我们在某些服务中采用加密技术（如SSL等）来保护您所提供的个人信息。然而，请理解，由于技术限制以及互联网行业中可能发生的各种恶意手段，即使我们已尽最大的努力、采取各类安全措施，我们仍然无法确保您的信息在任何时间均处在100%安全的防护下。同时，您需要了解，由于某些我们无法控制的因素，您在访问部分系统或通信网络使用我们的服务时，可能会遇到某些问题。
      <br>
      注册账户及使用我们产品和服务过程中包含的个人信息只能由广联达及其附属公司的员工，基于其工作产生的合理的处理需求进行处理。所有处理您个人信息的人员均受保密义务的约束。
      <br>

    </div>
    <div class="part">
      7.	您的权利
      <br>
      根据相关数据保护法律规定，就我们所使用的您的信息，您享有以下权利：
      <br>
      ●	您有权请求访问您的信息；
      <br>
      ●	如果信息不准确或不完整，您有权请求更新或修改您的信息；
      <br>
      ●	因与您有关的特定理由，您有权反对您的信息的某些使用（包括直接营销，数据画像，基于合法利益的处理，以及用于科学或历史研究和统计的处理）；
      <br>
      ●	在某些情况下，您有权要求删除您的信息或限制信息的使用（例如，除了某些例外情况，如部分信息对实现信息收集时的目的已非必要时，您有权要求我们删除该等信息）;
      <br>
      ●	当对您的信息的处理是基于您的同意或为了履行与您的合同，且这种处理是通过自动化的方式进行的，出于自身使用的目的，您有权要求我们返还您提供给我们的信息（通常称为数据可携权）；
      <br>
      ●	向相关监管机构提出投诉。
      <br>
      您可以与我们联系行使您的权利，或者可以通过您的应用和产品行使访问、更新和删除信息的权利，我们将协助您行使您的权利。如果您对这些权利有任何疑问或者希望行使这些权利，请发送电子邮件至[webmaster@glodon.com]。
      <br>
      请注意，如果您决定不向我们提供我们要求的信息，您可能无法访问服务的所有功能，包括但不限于以下内容：
      <br>
      ●	您可能无法下载，安装和/或使用我们的任何服务和/或任何更新和升级。
      <br>
      ●	您可能无法订阅或登录我们的服务，也无法购买任何附属服务。
      <br>
      ●	我们可能无法了解您在使用服务中遇到的问题，我们可能无法充分回应您的需求和建议。
      <br>
      ●	我们针对儿童的政策
      <br>
      为了保护儿童的隐私和安全，我们将对儿童的个人数据提供特殊的保护。我们不对16岁以下的儿童提供服务，并且我们不会故意或在明确知道的情况下收集儿童的个人数据。如果您是16岁以下的儿童，除非您的父母提供明确同意且该等同意可被证实，否则您将不被允许使用和安装我们的产品或创建属于您的账号。
      <br>
      如16岁以下的儿童下载、安装或使用任何我们的服务，无论是部分服务或全部服务的下载或使用，该等行为将被视为他/她的父母已经同意我们的政策和条款，包括但不限于同意本隐私政策。
      <br>
    </div>
  </div>
</template>
<style lang="less" type="text/less">
  @import "defaultStyle";
</style>
<script>
export default {
  name: 'PrivacyProtocol'
}
</script>
